var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 inputbox" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.content,
              expression: "content"
            }
          ],
          staticClass: "form-control",
          attrs: { id: "textbutton", readonly: "", type: "text" },
          domProps: { value: _vm.content },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.content = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-copy",
            on: {
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.copyToClipboard()
              }
            }
          },
          [_vm._v("Copiar")]
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 textbox" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.contentDescontos,
              expression: "contentDescontos"
            }
          ],
          staticClass: "form-control",
          attrs: { id: "textbuttondescontos", readonly: "" },
          domProps: { value: _vm.contentDescontos },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.contentDescontos = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.copyDescontosToClipboard()
              }
            }
          },
          [_vm._v("Copiar")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-9" }, [
        _c("div", { staticClass: "photo-container row" }, [
          _c("div", { staticClass: "col-md-8" }, [
            _c("img", {
              attrs: { src: _vm.image },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.selectImage()
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              ref: "uploadBtn",
              staticClass: "input-photo",
              attrs: { type: "file" },
              on: { change: _vm.uploadImage }
            })
          ]),
          _vm._v(" "),
          !_vm.isUploadingImage
            ? _c("div", { staticClass: "col-md-4" }, [
                _c("span", [
                  _vm._v(
                    "Clique na imagem ao lado para adicionar uma nova foto."
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("Tamanho recomendado 1920x700. Max 2,5MB")])
              ])
            : _c("div", { staticClass: "col-md-4" }, [
                _c("span", [_vm._v("Aguarde...")])
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _vm.showMsg
          ? _c(
              "div",
              {
                staticClass: "alert alert-danger alert-dismissible fade show",
                attrs: { role: "alert" }
              },
              [
                _vm._v("\n        " + _vm._s(_vm.msg) + "\n        "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Fechar"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.hideMessage()
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showSuccessMsg
          ? _c(
              "div",
              {
                staticClass: "alert alert-success alert-dismissible fade show",
                attrs: { role: "alert" }
              },
              [
                _vm._v("\n        " + _vm._s(_vm.successMsg) + "\n        "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Fechar"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.hideMessage()
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-save",
            on: {
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.saveStore()
              }
            }
          },
          [_vm._v("Salvar Loja")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 intro" }, [
        _c("h4", [_vm._v("Compartilhe nossos Descontos do Bem")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Compras originadas desse link irão gerar valores que serão retornados em benefício do projeto."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 intro" }, [
        _c("h4", [_vm._v("Botão de Descontos")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            'Copie o código abaixo e insira no site de sua Organização Social ou blog.\n        Ao clicar em nosso botão "Contribuir com Click2giv" os visitantes de seu site e blog\n        serão direcionados para a página de meios de pagamentos vinculados à sua Organização\n        ou campanha publicada na click2giv.'
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("h4", [_vm._v("Vitrine")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Adicione uma imagem para a Loja Oficial do Projeto.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60bb2960", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60bb2960","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manage-project/LinkDescontos.vue
// module id = null
// module chunks = 